export const GRUPOSAESA_LOGO = `${process.env.REACT_APP_ASSETS_URL}/images/grupo-saesa-logo-blanco.svg`;
export { default as LOGIN_LOGO } from './login-logo.svg'; 
export { default as USER_LOGO } from './user-logo.svg'; 
export { default as ERROR } from './error.svg'; 
export { default as MODAL_GUARDAR_ICONO } from './modal-guardar-icono.svg'; 
export { default as MODAL_ADVERTENCIA_ICONO } from './modal-advertencia-icono.svg';  
export { default as RESET_ICONO } from './reset.svg'; 
export { default as EXPORT_ICONO } from './export.svg'; 
export { default as EXPORT_ICONO_DISABLED } from './export-disabled.svg'; 
export { default as ICONO_ERRROR } from './icono-error.svg'; 
export { default as USER_ICONO } from './user-icono.svg'; 
export { default as DOWNLOAD_ICONO } from './download.svg';
export { default as LOADING_ICONO } from './loader.svg';
export { default as INFO_ICONO } from './infoIcon.svg';
export { default as PDF_MINI_ICON } from './pdfMiniIcon.svg';
export { default as EXCEL_MINI_ICON } from './excelMiniIcon.svg';
export { default as DOCUMENT_UPLOAD } from './document-upload.svg';
export { default as CANCEL_ICON } from './cancelIcon.svg';
export { default as ERROR_ICON_GREY } from './error-grey.svg';
export { default as ERROR_CONEXION_GREY } from './error-conexion.svg';
export { default as EXPORT_AZUL } from './export-azul.svg';
export { default as TRASH_AZUL } from './trash-azul.svg';
export { default as EDIT_AZUL } from './edit-azul.svg';











